import React from "react";
import "./hero.less";
import { formatListingDate } from "../../../../utils/financialHelper";
import { useNavigate, useLocation } from "react-router-dom";

interface BannerProps {
  reitData: {
    image: string;
    name: string;
    locations: string;
    assetClass: string;
    listingDate: string;
    bse: { label: string; value: number; change: number };
    nse: { label: string; value: number; change: number };
    buttons: string[];
  };
}

const HeroBanner: React.FC<BannerProps> = ({ reitData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const reitId = location.state?.reitId; // optional state passed

  return (
    <section className="hero-banner">
      <div className="hero-banner__backdrop"></div>
      <button
        className="hero-banner__back-btn"
        onClick={() => {
          if (reitId) {
            navigate(`/reits/${reitId}`);
          } else {
            navigate(-1);
          }
        }}
        aria-label="Go Back"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </button>

      <div className="hero-banner__content">
        {/* Left Image */}
        <div className="hero-banner__image">
          <img src={reitData.image} alt={reitData.name} />
        </div>

        {/* Right Content */}
        <div className="hero-banner__details">
          {/* Header Section */}
          <div className="hero-banner__header">
            <div className="hero-banner__header-info">
              <h2 className="hero-banner__title">{reitData.name}</h2>
              <p className="hero-banner__location">{reitData.locations}</p>
            </div>
            <div className="hero-banner__header-stats">
              <p className="hero-banner__stat">
                Primary Asset Class: <strong>{reitData.assetClass}</strong>
              </p>
              <p className="hero-banner__stat">
                Listing Date:{" "}
                <strong>{formatListingDate(reitData.listingDate)}</strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
